var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPark = function SvgPark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#461B14",
    d: "M1 20C1 9.507 9.507 1 20 1s19 8.507 19 19-8.507 19-19 19S1 30.493 1 20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M1 20C1 9.507 9.507 1 20 1s19 8.507 19 19-8.507 19-19 19S1 30.493 1 20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.25,
    d: "M26.135 17.804V27.5M13.18 25.15v2.35m7.021-2.35v2.35m-.88-6.141v1.905m-5.462-1.905v1.905m12.277-9.514c1.444 0 2.615 1.184 2.615 2.645v2.928c0 1.46-1.17 2.645-2.615 2.645-1.444 0-2.615-1.184-2.615-2.645v-2.928c0-1.46 1.171-2.645 2.615-2.645Zm-13.707 5.893h8.413v1.67h-8.413zm-.375 3.647h9.17c.44 0 .802.367.802.812v1.034H11.25v-1.034c0-.445.362-.812.803-.812Z"
  })));
};
export default SvgPark;